module.exports = __webpack_public_path__ + "img/PriceQuotations_AcceptQuotesFormCustomer.2b4f3426.svg";